/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartSummary',[
    'jquery',
    'global/all',
    './CartManager',
    './CartLocker',
], function ($, Roc, CartManager, CartLocker) {
    'use strict';

    var baseApiUrl;
    var checkoutUrl;
    var cartFlyoutTmpSelector;
    var $cartTotalItems;

    // the mode in which the "item added to cart" flyout is operating in
    //   "cart"     - this flyout is displaying on the cart page (so we only display the flyout if there are errors/warning adding to cart)
    //   "default"  - this flyout is displaying on any other page, and should always display
    var cartFlyoutMode;

    function reloadSummary() {
        Roc.Logger.debug('Loading Cart Summary...');
        CartManager.getSummary();
    }

    function showRecentCart(data) {
        data.checkoutUrl = checkoutUrl;
        data.flyoutMode = cartFlyoutMode;

        Roc.UI.template(cartFlyoutTmpSelector, data).then(function (renderedTemplate) {
            Roc.UI.Modal.open(renderedTemplate);
        });
    };

    function itemAddedEvt(data) {
        if (data && data.success) {
            reloadSummary();

            if (shouldShowFlyout(data)) {
                //OmniCable custom code : checking for quote only cart
                data.isQuoteOnly = false;
                _.forEach(data.errors,
                    function (error) {
                        if (error.errorMessage === 'Quote Only Cart') {
                            data.isQuoteOnly = true;
                        };
                    });
                //End custom code
                showRecentCart(data);
            }
        }
    }

    function itemUpdated(data) {
        if (data && data.details) {
            reloadSummary();
        }
    }

    function updateQtyOnPage(qty) {
        $cartTotalItems.html('My Cart (' + qty + ')');
    }

    function updateQty(xhr) {
        var summary = xhr.responseJSON || {};
        if (summary.items) {
            var totalItems = parseInt(summary.items);
            if (!isNaN(totalItems)) {
                updateQtyOnPage(totalItems);
                return;
            }
        }
        updateQtyOnPage(0);
    }

    function updateCartLockFlag(xhr) {
        var summary = xhr.responseJSON || {};
        if (summary.isLocked) {
            CartLocker.setLockFlag();
        } else {
            CartLocker.clearLockFlag();
        }
    }

    // Custom handler that updates cart items quantity in the site header when full cart model is loaded from the API
    function updateQtyFromFullCart(cart) {
        if (cart !== undefined && cart !== null && cart.items && _.isArray(cart.items)) {
            var summedQty = 0;
            _.each(cart.items, function(item) {
                summedQty += item.uomId === null || item.uomId === undefined
                    ? item.quantity
                    : item.uomQuantity;
            });
            updateQtyOnPage(summedQty);
        }
    }

    function updateCartLockFlagFromFullCart(cart) {
        if (cart && cart.customFields && cart.customFields.quoteId) {
            CartLocker.setLockFlag();
        } else {
            CartLocker.clearLockFlag();
        }
    }

    /**
     * Should the "item added to cart" flyout/modal display on this page?
     * @param {any} data - The data provided by the `Roc.Events.cart.ADD_ITEM` event.
     */
    function shouldShowFlyout(data) {
        if (cartFlyoutMode === 'cart') {
            // if the flyout is in cart page mode, we display the flyout if there are errors worth showing
            return data.errors && data.errors.length > 0;
        }
        // otherwise, we're in default mode - so always display the flyout
        return true;
    }

    function bindEvents() {
        Roc.EventManager.bind(Roc.Events.cart.ADD_ITEM, itemAddedEvt);
        Roc.EventManager.bind(Roc.Events.cart.UPDATE_ITEM, itemUpdated);
        Roc.EventManager.bind(Roc.Events.cart.REMOVE_ITEM, reloadSummary);
        Roc.EventManager.bind(Roc.Events.cart.SAVE_ITEM, reloadSummary);
        Roc.EventManager.bind(Roc.Events.cart.MOVE_SAVED_ITEM, itemAddedEvt); 
        Roc.EventManager.bind(Roc.Events.cart.GET_SUMMARY, function(xhr) {
            updateQty(xhr);
            updateCartLockFlag(xhr);
        });
        Roc.EventManager.bind(Roc.Events.cart.CART_LOADED, reloadSummary);
        Roc.EventManager.bind(Roc.Events.cart.RE_ORDER, reloadSummary);
        Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART, function(xhr) {
            updateQtyFromFullCart(xhr);
            updateCartLockFlagFromFullCart(xhr);
        });
    }

    function init(options) {
        baseApiUrl = options.baseApiUrl;
        cartFlyoutTmpSelector = options.cartFlyoutTmpSelector;
        $cartTotalItems = $('#spanCartTotal');
        checkoutUrl = options.checkoutUrl;
        cartFlyoutMode = options.cartFlyoutMode;
        bindEvents();

        reloadSummary();
    }

    var CartSummary = { init: init };

    Roc.Logger.debug('CartSummary.js Loaded:', CartSummary);

    return CartSummary;
});
